import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import CustomCard from "../../SharedComponents/CustomCard";
import { groupBy } from "../../Utils/js-common";
import { annotationCustomCardStyles, communityDetailsStyles as styles } from "./CommunityDetails.styles";
import { CUSTOMER_VIEW_STYLES } from "./CustomerView.styles";


const communityList = ["Security", "Entra", "Management", "Information Protection"] as const;
const communityDisplayMap: Record<(typeof communityList)[number], string> = {
  "Security": "Threat Protection",
  "Entra": "Entra",
  "Management": "Management",
  "Information Protection": "Purview"
};

const CommunityAnnotations = (props: any) => {
  const [annotationFlags, setAnnotationFlags] = React.useState<{ annotationText: string; present: boolean }[]>([]);
  const customCardContainerAdjustedHeight = [
    CUSTOMER_VIEW_STYLES.COMMON_STYLES.CLASS_NAMES.customCardContainer,
    styles.customCardContainerAdjustedHeight
  ].join(" ");

  React.useEffect(() => {
    if (props.annotationData) {
      const communityGroupedData = Object.keys(groupBy(props.annotationData, "community"));
      const flags = communityList.map((annotationText) => {
        const present = communityGroupedData.some((value) =>
          value.toLowerCase().includes(annotationText.toLowerCase())
        );
        return {
          annotationText: communityDisplayMap[annotationText] ?? annotationText,
          present
        };
      });
      setAnnotationFlags(flags);
    }
  }, [props.annotationData]);

  return (
    <div className={customCardContainerAdjustedHeight}>
      <CustomCard cardHeaderTitle={"Membership"} styles={annotationCustomCardStyles} kustoLink={props.kustoLink}>
        <ul className={styles.grid}>
          {annotationFlags.map(({ annotationText, present }, index) => (
            <li key={index} className={styles.row}>
              <span className={styles.name}>{annotationText + " Advisors"}</span>
              <span className={styles.colon}>:</span>
              <span role="img" aria-label={present ? "Active" : "Inactive"} className={styles.status}>
                {present ? (
                  <CheckIcon titleAccess="true" sx={{ color: "green" }} />
                ) : (
                  <CloseIcon titleAccess="false" sx={{ color: "red" }} />
                )}
              </span>
            </li>
          ))}
        </ul>
      </CustomCard>
    </div>
  );
};

export default CommunityAnnotations;
